/* import __COLOCATED_TEMPLATE__ from './segment.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const Segment = templateOnlyComponent<Signature>();
export default Segment;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::Segments::Segment': typeof Segment;
    'inbox2/conversation-details-sidebar/sidebar-sections/segments/segment': typeof Segment;
  }
}
